import type { Placement } from "./types.ts";

export const isHorizontalPlacement = (placement: Placement): placement is "top" | "bottom" =>
  placement === "top" || placement === "bottom";
